/** New release (spec §10.7): the service worker reports a waiting update, or an API response carries a different
 * X-App-Version. Either way the user is offered a reload; it activates the new service worker when there is one. */
import { useEffect } from 'react'
import { toast } from 'sonner'
import { useRegisterSW } from 'virtual:pwa-register/react'
import { apiEvents } from '@/lib/api/client'
import { t } from '@/lib/text'

export function VersionPrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW()

  useEffect(() => {
    function offer() {
      toast(t('core.shell.new_version'), {
        id: 'new-version',
        duration: Infinity,
        action: {
          label: t('core.shell.reload'),
          onClick: () => {
            // Without a registered service worker updateServiceWorker does nothing, so reload as well.
            void updateServiceWorker(true).finally(() => window.location.reload())
          },
        },
      })
    }
    if (needRefresh) offer()
    return apiEvents.onVersionChange(offer)
  }, [needRefresh, updateServiceWorker])
  return null
}
